import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import i18n from '../../utils/i18n';
import DocumentSelectionModal from '@adsk/bim360-matrix-react-document-selection-modal';
import {filterAllowedDocuments} from '../../utils/attachmentsHelper';
import {ENV_CONFIGS} from '../../constants/envs';
import {createGetFolderContentsMethod, createHasMoreFolderContents} from '../../utils/docsApiHelpers';

class LinkToDocument extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isDocumentSelectionModalOpen: false,
      document: null
    };
    this.handleMessage = this.handleMessage.bind(this);
  }

  componentDidMount() {
    window.addEventListener('message', this.handleMessage);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleMessage);
  }

  handleMessage(event) {
    if (event.origin === ENV_CONFIGS.DOCS) {
      const actionType = event.data.actionType;
      // eslint-disable-next-line default-case
      switch (actionType) {
        case 'linkPushpinDone':
          this.handlePushpinSelection(event);
          break;
        case 'cancelLinkPushpin':
          this.handlePushpinCancel(event);
          break;
      }
    }
  }

  handlePushpinSelection(event) {
    const {pushpin, currentSheet, thumbnail} = event.data.params;
    // simplify current sheet object received from issues-ui consumer
    if (currentSheet && currentSheet.viewableID) {
      currentSheet.viewableId = currentSheet.viewableID;
      delete currentSheet.viewableID;
    }
    this.props.closePushpinSelection();
    this.props.onSelectDocumentPushpin({document: this.state.document, issuePushpin: pushpin, currentSheet, thumbnail});
  }

  handlePushpinCancel() {
    this.setState({document: null});
    this.props.closePushpinSelection();
  }

  getProjectFolders() {
    const documentsCache = {};
    // This method is called every time we load the tree from scratch. That's why we need to clean the cache here - for it to be relevant for the current tree.
    this.getFolderContentsWrapped = createGetFolderContentsMethod(documentsCache, this.props.fetchFolderContents);
    this.hasMoreFolderContentsWrapped = createHasMoreFolderContents(documentsCache);
    return new Promise((resolve, reject) => {
      this.props.fetchProjectFolders(resolve, reject);
    });
  }

  getFolderContents(urn) {
    return this.getFolderContentsWrapped(urn).then(data => filterAllowedDocuments(data, this.props.currentLinkedUrn));
  }

  hasMoreFolderContents(context) {
    return this.hasMoreFolderContentsWrapped(context);
  }

  showDocumentSelectionModal() {
    this.setState({isDocumentSelectionModalOpen: true});
  }

  hideDocumentSelectionModal() {
    this.setState({isDocumentSelectionModalOpen: false});
  }

  handleLinkToDocumentSelection(urn, document) {
    this.setState({document});
    this.hideDocumentSelectionModal();
    this.props.openPushpinSelection(document, this.props.status);
  }

  render() {
    const textSelect = i18n.t('navigation.select');
    const classes = classNames('LinkToDocument', this.props.className);

    return (
      <div className={classes}>
        {this.props.children(() => this.showDocumentSelectionModal())}
        <DocumentSelectionModal
          container={this.props.container}
          isModalOpen={this.state.isDocumentSelectionModalOpen}
          closeModal={this.hideDocumentSelectionModal.bind(this)}
          isSaving={false}
          saveButtonText={textSelect}
          onChoosingDocument={this.handleLinkToDocumentSelection.bind(this)}
          getRootFolders={this.getProjectFolders.bind(this)}
          getFolderContents={this.getFolderContents.bind(this)}
          hasMoreFolderContents={this.hasMoreFolderContents.bind(this)}
        />
      </div>
    );
  }
}

LinkToDocument.displayName = 'LinkToDocument';

LinkToDocument.propTypes = {
  children: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
  container: PropTypes.object.isRequired,
  onSelectDocumentPushpin: PropTypes.func.isRequired,
  fetchProjectFolders: PropTypes.func.isRequired,
  fetchFolderContents: PropTypes.func.isRequired,
  openPushpinSelection: PropTypes.func.isRequired,
  closePushpinSelection: PropTypes.func.isRequired,
  viewType: PropTypes.string.isRequired,
  className: PropTypes.string,
  currentLinkedUrn: PropTypes.string
};

export default LinkToDocument;
